<div class="basic-bar-chart_container" [ngClass]="{'dark-mode': isDarkMode, 'full-chart': labels.configs.length == 0}">
     <span class="force-text" *ngIf="forceDisplayText != ''">{{forceDisplayText}}</span>
     <div class="chart-wrapper" *ngIf="forceDisplayText == ''">
          <canvas #barChartCanvas></canvas>
          <div class="tube-overlay-row">
               <div class="tube-cell" *ngFor="let i of groupIndexes">
                    <img *ngIf="tubeFrameIndexs.includes(i)" class="tube-feeding-icon" src="assets/icons/tube-feeding.svg"/>
               </div>
          </div>
     </div>
     <div class="bottom-lable" *ngIf="(labels.configs?.length ?? 0) > 0 && forceDisplayText == ''">
          <ng-container *ngTemplateOutlet="labels.type == 1 ? type1 : type2; context: { $implicit: labels }"></ng-container>
     </div>
</div>

<ng-template #type1>
     <label *ngFor="let label of labels.configs" class="label">{{label}}</label>
</ng-template>

<ng-template #type2>
     <caremoni-dynamic-label [data]="labels.configs[0].value" [config]="labels.configs[0].settings"></caremoni-dynamic-label>
</ng-template>
